import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AdminService from "../../../api/services/adminService";
import "../Home/Homepage.css";
import "./DownlineViewPage.css";
import {
  SEARCH_STORAGE_KEY,
  accessMessage,
  dash,
  formatDate,
  kycKind,
  statusKind,
} from "./downlineViewShared";

const Chip = ({ kind, children }) => <span className={`dv-chip dv-chip--${kind}`}>{children}</span>;

const DownlineViewPage = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState(() => sessionStorage.getItem(SEARCH_STORAGE_KEY) || "");
  const [loading, setLoading] = useState(false);
  const [emptyHint, setEmptyHint] = useState(false);
  const [error, setError] = useState("");
  const [hasMore, setHasMore] = useState(false);
  const [searched, setSearched] = useState(false);
  const [rows, setRows] = useState([]);

  const handleSearch = async (event) => {
    event.preventDefault();
    const search = query.trim();
    if (!search) {
      setEmptyHint(true);
      setError("");
      setSearched(false);
      setRows([]);
      setHasMore(false);
      return;
    }
    if (search.length > 80) {
      setEmptyHint(false);
      setError("search must be 80 characters or less");
      return;
    }

    setEmptyHint(false);
    setLoading(true);
    setError("");
    try {
      const res = await AdminService.searchDownlineView(search);
      if (res?.success) {
        sessionStorage.setItem(SEARCH_STORAGE_KEY, search);
        setRows(Array.isArray(res.data) ? res.data : []);
        setHasMore(Boolean(res.has_more));
        setSearched(true);
      } else {
        setRows([]);
        setHasMore(false);
        setSearched(false);
        setError(accessMessage(res, "Search failed"));
      }
    } catch (err) {
      setRows([]);
      setHasMore(false);
      setSearched(false);
      setError(err?.message || "Search failed");
    } finally {
      setLoading(false);
    }
  };

  const openView = (userId) => {
    if (!userId) return;
    navigate(`/dashboard/referral/downline-view/${userId}`);
  };

  return (
    <main className="dashboard-main dashboard-subpage dv-page">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Downline View</span>
          </p>
          <h1 className="dashboard-hero__title">Downline View</h1>
          <p className="dashboard-hero__subtitle">
            Search a user to see their wallets, staking, trades and downline commission
          </p>
        </div>
        <div className="dashboard-hero__icon dv-hero__icon">
          <i className="fas fa-layer-group" />
        </div>
      </section>

      <div className="dashboard-body dashboard-content-inner">
        <form className="dv-search" onSubmit={handleSearch}>
          <input
            type="text"
            value={query}
            maxLength={80}
            placeholder="Name, email, mobile, UUID or referral code"
            onChange={(e) => {
              setQuery(e.target.value);
              if (emptyHint) setEmptyHint(false);
            }}
          />
          <button type="submit" className="dv-btn" disabled={loading}>
            {loading ? "Searching..." : "Search"}
          </button>
        </form>

        {emptyHint ? <p className="dv-hint">Search likho</p> : null}
        {error ? <p className="dv-error">{error}</p> : null}
        {searched && hasMore ? (
          <p className="dv-warn">20 se zyada users mile. Naam, email, mobile ya UUID poora likho.</p>
        ) : null}

        {searched && !loading && rows.length === 0 ? <p className="dv-empty">No users matched</p> : null}

        {searched && rows.length > 0 ? (
          <div className="dv-table-wrap">
            <table className="dv-table">
              <thead>
                <tr>
                  <th>UUID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Referral code</th>
                  <th>KYC</th>
                  <th>Status</th>
                  <th>Direct referrals</th>
                  <th>Registered</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.user_id || row.uuid}>
                    <td>{dash(row.uuid)}</td>
                    <td>{dash(row.name)}</td>
                    <td>{dash(row.email)}</td>
                    <td>{dash(row.mobile)}</td>
                    <td>{dash(row.referral_code)}</td>
                    <td>
                      <Chip kind={kycKind(row.kyc_label)}>{dash(row.kyc_label)}</Chip>
                    </td>
                    <td>
                      <Chip kind={statusKind(row.account_status)}>{dash(row.account_status)}</Chip>
                    </td>
                    <td>{row.total_direct_referrals ?? 0}</td>
                    <td>{formatDate(row.registered_at)}</td>
                    <td>
                      <button type="button" className="dv-btn dv-btn--small" onClick={() => openView(row.user_id)}>
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    </main>
  );
};

export default DownlineViewPage;
